// extracted by mini-css-extract-plugin
export var container = "_i0-1";
export var cornerButtonContainer = "_i0-6";
export var disabled = "_i0-2";
export var dragActive = "_i0-3";
export var fileContainer = "_i0-5";
export var hiddenInput = "_i0-4";
export var widthContainer = "_i0-0";